import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { versions } from 'environments/versions';

@Injectable({
    providedIn: 'root'
})
export class AppConfigService {
    private appConfig: any;
    private baseUrl: string;
    private http: HttpClient;
    constructor(private handler: HttpBackend)
    {
        this.http = new HttpClient(handler);
        this.baseUrl = document.getElementsByTagName('base')[0].href;
    }

	loadAppConfig() {
		const rutaAppConfig = this.baseUrl + 'api/appconfig' + `?v=${versions.revision.trim()}`;
		return this.http.get(rutaAppConfig)
             .toPromise()
             .then(data => {
                 this.appConfig = data;
                 this.appConfig.BaseUrl = this.baseUrl;
             });
    }

    get BaseUrl() {
        if (!this.appConfig) {
            throw Error('Config file not loaded!');
        }
        return this.appConfig.BaseUrl;
    }

    get OicUrl() {

        if (!this.appConfig) {
            throw Error('Config file not loaded!');
        }

        return this.appConfig.oicUrl;
    }

    get IdentityAdminUrl() {

        if (!this.appConfig) {
            throw Error('Config file not loaded!');
        }

        return this.appConfig.identityAdminUrl;
    }

    get ClientId() {

        if (!this.appConfig) {
            throw Error('Config file not loaded!');
        }

        return this.appConfig.clientId;
	}

    get Scope() {

        if (!this.appConfig) {
            throw Error('Config file not loaded!');
        }

        return this.appConfig.scope;
    }

    get OicDynamic() {

        if (!this.appConfig) {
            throw Error('Config file not loaded!');
        }

        return false;
    }

}

 